<template>
  <p class="pt-4">
    {{ $t('state.about_content_deadline') }}
  </p>
</template>
